/* eslint-disable */
const mutations = {
  updateIsLoading(state, { isLoading }) {
    state.isLoading = isLoading;
  },

  setCollection(state, { collection }) {
    state.data = collection;
  },

  updateCollection(state, { collection }) {
    state.data = {
      ...state.data,
      ...collection,
    };
  },

  updateCollectionPhotos(state, { photos }) {
    state.data.photos = photos;
  },
};

export default mutations;
